import React from "react";
import { HeaderForNoting } from "@components/header";
import { checkIsMobile } from "@/utils/checkmobile";
import { Toolbar } from "@mzc-pdc/ui";
import { useLocation } from "react-router-dom";

const LayoutForNoting = ({ children }) => {
    const isMobile = checkIsMobile();
    const { pathname } = useLocation();
    return (
        <div className={"wrap wrap-gate" + (isMobile ? " is-mobile" : "")}>
            {pathname.indexOf("customMenuSets/common") === -1 && <HeaderForNoting />}
            <div>
                <Toolbar />
                <div className={"container"}>
                    <div className={"main"}>
                        {/*TODO: MUI로 개선 필요*/}
                        <div className={"contents"} style={{ maxHeight: `calc(100vh - 56px)`, overflowY: "auto" }}>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LayoutForNoting;
